import Loader from './Loader';
import LoaderContainer from './LoaderContainer';

export default Loader;
export {LoaderContainer};
